import PropTypes from 'prop-types';

export * from '../../node_modules/react-intl';

export const intlShape = PropTypes.shape({
  formatDate: PropTypes.func.isRequired,
  formatTime: PropTypes.func.isRequired,
  formatMessage: PropTypes.func.isRequired,
});
